export const projectIqTokens = {
  navy: "#142539" as const,
  navy2: "#1b3047" as const,
  navy3: "#24405b" as const,
  navyLine: "#2c4863" as const,

  teal: "#0e9aa7" as const,
  teal2: "#18b3c0" as const,
  tealSoft: "#e6f6f8" as const,
  tealLine: "#b9e4e9" as const,
  tealInk: "#0b6d77" as const,

  ink: "#1d2733" as const,
  ink2: "#3a4756" as const,
  ink3: "#51637a" as const,
  muted: "#6c7a89" as const,
  faint: "#9aa6b2" as const,

  bg: "#f6f7f9" as const,
  bg2: "#f0f2f5" as const,
  card: "#ffffff" as const,
  paper: "#f3f4f1" as const,
  paper2: "#fbfbf9" as const,

  line: "#e6e9ed" as const,
  line2: "#eef1f4" as const,
  rule: "rgba(20,37,57,0.14)" as const,
  ruleSoft: "rgba(20,37,57,0.08)" as const,
  ruleStrong: "#142539" as const,

  amber: "#d98a2b" as const,
  green: "#2f9e6e" as const,
  greenBg: "rgba(47,158,110,0.12)" as const,
  violet: "#6b6ad9" as const,
  violetBg: "rgba(107,106,217,0.12)" as const,
  violetInk: "#4c4bb0" as const,
  rust: "#c2553f" as const,
  rustBg: "rgba(194,85,63,0.10)" as const,
  blue: "#3f8fc2" as const,
  blueBg: "rgba(63,143,194,0.12)" as const,

  shadowSm:
    "0 1px 2px rgba(20,37,57,0.06), 0 1px 3px rgba(20,37,57,0.04)" as const,
  shadow:
    "0 2px 6px rgba(20,37,57,0.06), 0 8px 24px rgba(20,37,57,0.06)" as const,
  shadowLg: "0 12px 40px rgba(20,37,57,0.14)" as const,

  fontFamily: "'Hanken Grotesk', system-ui, -apple-system, sans-serif" as const,
  fontFamilyMono: "'IBM Plex Mono', ui-monospace, monospace" as const,

  sidebarBg: "#142539" as const,
  sidebarWidth: "252px" as const,
  sidebarAccent: "#0e9aa7" as const,
  sidebarMuted: "#9aa6b2" as const,
  sidebarSelected: "rgba(255,255,255,0.15)" as const,
  sidebarActiveBg: "rgba(24,179,192,0.22)" as const,
  sidebarHover: "rgba(255,255,255,0.07)" as const,
  sidebarBorder: "rgba(255,255,255,0.12)" as const,
  sidebarFadedText: "rgba(255,255,255,0.60)" as const,
  sidebarSubtleBg: "rgba(255,255,255,0.04)" as const,
  sidebarItemText: "rgba(255,255,255,0.82)" as const,
  sidebarItemSubtext: "rgba(255,255,255,0.42)" as const,
  sidebarDimText: "rgba(255,255,255,0.45)" as const,
  navSectionLabel: "rgba(255,255,255,0.40)" as const,
  pinPinnedBg: "rgba(24,179,192,0.22)" as const,
  pinUnpinnedBg: "rgba(255,255,255,0.08)" as const,

  workspaceNavBg: "#ffffff" as const,
  navItemText: "#3a4756" as const,
  navItemActiveText: "#0b7d88" as const,
  navItemActiveBg: "rgba(14,154,167,0.10)" as const,
  navIconInactive: "#51637a" as const,
  navSectionHeaderShadow: "0 4px 12px rgba(14,154,167,0.22)" as const,

  addButtonBg: "rgba(255,255,255,0.10)" as const,
  addButtonText: "rgba(255,255,255,0.75)" as const,
  addButtonBgHover: "rgba(255,255,255,0.18)" as const,
  addButtonBgActive: "rgba(255,255,255,0.22)" as const,

  sidebarAvatarSize: "44px" as const,
  sidebarAvatarRadius: "12px" as const,
  sidebarAvatarFontSize: "13.5px" as const,
  sidebarAvatarBg: "rgba(255,255,255,0.08)" as const,
  sidebarAvatarInactiveText: "rgba(255,255,255,0.80)" as const,
  sidebarCollapsedActionBg: "rgba(255,255,255,0.06)" as const,
  sidebarCollapsedActionColor: "rgba(255,255,255,0.70)" as const,
  sidebarCollapsedAddColor: "rgba(255,255,255,0.60)" as const,
  sidebarCollapsedAddBorder: "rgba(255,255,255,0.20)" as const,

  statusAmber: "#d98a2b" as const,
  statusGreen: "#2f9e6e" as const,
  statusViolet: "#6b6ad9" as const,

  workspaceStatusColors: {
    green: "#0e700e",
    teal: "#038387",
    marigold: "#a74109",
    blue: "#0f548c",
    purple: "#7160e8",
  },

  avatarRingShadow: "0 0 0 2px #ffffff" as const,
  sidebarTextStrong: "#ffffff" as const,
  sidebarBorderHover: "rgba(255,255,255,0.20)" as const,
} as const;

export type ProjectIqTokens = typeof projectIqTokens;
